<app-header [userData]="userData" (onNewStreamClick)="newStream()">
</app-header>

<div
    class="streamarea col"
    [ngClass]="userStreams.length === 0 ? 'justify-center' : ''"
>
    <!-- Empty State -->
    @if (!userStreams.length || userStreams.length === 0) {
        <div
            class="col w100 gap-48 align-center justify-center align-self-center"
        >
            <div class="row w100 justify-center gap-8">
                @if (this.emptyStateElement.length !== 0) {
                    @for (element of emptyStateElement; track element) {
                        <app-stream-info-card
                            [title]="element.title"
                            [credits]="element.credits"
                            [streamId]="$any(element.streamId)"
                            [category]="element.categoryName"
                            [steps]="element.stepCount"
                            (onClick)="onStreamCardClick(element.streamId)"
                        >
                        </app-stream-info-card>
                    }
                }
            </div>

            <div class="col gap-8">
                <rr-btn type="Link" i18n (click)="newStream()">
                    Show all streams
                </rr-btn>
            </div>
        </div>
    }

    <!-- If streams exist -->
    @for (group of groupedStreams; track group.date) {
        <div class="usertreams col w100 gap-24">
            <div class="col w100 gap-8">
                <span class="uppercase-label">{{
                    group.date === today
                        ? 'Today'
                        : group.date === yesterday
                          ? 'Yesterday'
                          : group.date
                }}</span>
                <div class="col w100 groupedwrapper gap-4">
                    <app-stream-row
                        *ngFor="let stream of group.streams"
                        [streamName]="findStreamNameByConfigId(stream.configId)"
                        [stream]="stream"
                        [categories]="findCategorysByConfigId(stream.configId)"
                        (deleteStream)="deleteStream(stream.id)"
                    ></app-stream-row>
                </div>
            </div>
        </div>
    }
    <rr-disclaimer
        [type]="disclaimerType"
        [showIcon]="false"
        class="col w100"
    ></rr-disclaimer>
</div>
<rr-spinner *ngIf="isLoading"></rr-spinner>
